/* Generated USDT deposit helpers unit. */
// Input has already passed the native rich-text sanitizer. Preserve prose, remove bank actions.
export const withoutBankInquiryActions = (html) => {
  if (!html || typeof document === 'undefined') return '';
  const template = document.createElement('template');
  template.innerHTML = html;
  template.content.querySelectorAll('.bankAsk').forEach((element) => {
    (element.closest('button, a') || element).remove();
  });
  return template.innerHTML;
};
